import { z } from 'zod';
import { mediaSchema } from '../media.js';

const baseTaskSchema = z.object({
  id: z.string(),
  question: z.string().nullish().default(""),
  introduction: z.array(mediaSchema).default([]),
  hints: z.record(z.number(), z.string()).default({})
});

export { baseTaskSchema };
//# sourceMappingURL=schema.base.js.map
